module.exports = __webpack_public_path__ + "static/media/VectorModify.9d9f9025.svg";